import React, { memo, useState, useEffect } from "react";
import Select from "react-select";
import Loader from "react-loader-spinner";
import styles from "./select.module.scss";
import CustomLabel from '../CustomLabel';
import CustomHintMessage from '../CustomHintMessage';
import "./select.scss";
import { isBoolean } from "util";

const initialRequired = false;
const initialValidateInput = { minLength: null, validate: () => { } };

const CustomSelect = ({
    className,
    value,
    placeholder,
    onChange,
    options = [],
    loading = false,
    isSearchable = false,
    isMulti = false,
    label,
    noOptionsMessage,
    inputFilter = false,
    readOnly,
    messageError = "",
    hintMessage = null,
    required = [initialRequired, initialValidateInput],
    validate,
    add,
    ...resp
}) => {

    const _isSearchable = inputFilter ? true : isSearchable;

    const [_required, _setRequired] = useState(initialRequired);
    const [_validate, _setValidate] = useState(initialValidateInput);
    const [_showError, _setShowError] = useState(false);

    useEffect(() => {
        if (Array.isArray(required)) {
            _setRequired(required[0]);
            if (typeof required[1] === "object") {
                _setValidate(required[1]);
            }
        } else if (typeof required === "boolean") {
            _setRequired(required);
        }
    }, [required]);

   useEffect(() => {
    if (_required) {
        let hasAnError = false;

        if (isMulti) {
            if (!Array.isArray(value) || value.length === 0) {
                hasAnError = true;
            }
        } else {
            if (!value?.value) {
                hasAnError = true;
            }
        }

        if (
            _validate?.minLength &&
            isMulti &&
            Array.isArray(value) &&
            value.length < _validate.minLength
        ) {
            hasAnError = true;
        }

        if (
            typeof _validate?.validate === "function" &&
            !isMulti &&
            !_validate.validate(value?.value)
        ) {
            hasAnError = true;
        }

        _setShowError(hasAnError);
    }
}, [value, isMulti]);

    return (
        <div className={`${className} ${styles.container} ${inputFilter && styles.filter} ${add && styles.add}`}>
            {
                label &&
                <CustomLabel className={styles.label} required={_required} error={_showError} >
                    {label}
                </CustomLabel>

            }
            <div className={styles.select}>
                <Select
                    options={options}
                    classNamePrefix="custom"
                    isSearchable={_isSearchable}
                    placeholder={placeholder}
                    onChange={onChange}
                    isDisabled={isBoolean(readOnly) ? readOnly : loading}
                    value={value}
                     isMulti={isMulti} 
                    noOptionsMessage={noOptionsMessage}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    menuPlacement="auto"
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 }),
                      menu: base => ({ ...base, zIndex: 9999 })
                    }}
                    className={_showError && styles.error}
                    {...resp}
                />
            </div>
            {loading && <Loader type="ThreeDots" className={`${styles.loader} ${label && styles.loaderWithLabel}`} />}

            {
                typeof hintMessage === "string" &&
                <CustomHintMessage message={hintMessage} className={styles.hintMessage} />
            }

            {
                (typeof messageError === "string" && _showError) &&
                <CustomHintMessage message={messageError} className={styles.hintMessage} error />
            }
        </div>

    );

};

export default memo(CustomSelect);
